import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, reactive, watch, onMounted } from 'vue'
    import { guid } from '@common/Guid'
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useAdminManageConnectorsPage } from '@Integrations/Connectors/pages-core'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'AdminManageConnectorsPage',
  setup(__props) {

    document.title = "Manage connectors"

    const tid = useOrganizationUnitId()

    const { useCurrentUserQuery, useConnectorsOfOrganizationQuery, useCreateConnectorCommand } = useAdminManageConnectorsPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { modelConnectorsOfOrganizationQueryV1, runConnectorsOfOrganizationQueryV1 } = useConnectorsOfOrganizationQuery(tid)
    const connectors = computed(() => modelConnectorsOfOrganizationQueryV1.value?.Connectors || [])

    const { invokeCreateConnectorCommandV1, succeedCreateConnectorCommandV1 } = useCreateConnectorCommand(() => guid(), tid, userId, null)

    onMounted(() => {
        runCurrentUserQueryV1()
        runConnectorsOfOrganizationQueryV1()
    })

    watch(succeedCreateConnectorCommandV1, () => runConnectorsOfOrganizationQueryV1())

    function handleCreateConnectorCommandV1() {
        const name = prompt('Enter a new connector name')
        if (name) { invokeCreateConnectorCommandV1({ Name: name }) }
    }

return { __sfc: true,tid, useCurrentUserQuery, useConnectorsOfOrganizationQuery, useCreateConnectorCommand, modelCurrentUserQueryV1, runCurrentUserQueryV1, userId, modelConnectorsOfOrganizationQueryV1, runConnectorsOfOrganizationQueryV1, connectors, invokeCreateConnectorCommandV1, succeedCreateConnectorCommandV1, handleCreateConnectorCommandV1 }
}

})